<gs-skeleton-loader class="avatar" appearance="circle" width="68" height="68" ></gs-skeleton-loader>
